import settings from '../settings.js'

const $inject = ['$scope', '$rootScope', '$ionicPopup', '$state', 'toastr', 'common', 'UserService', 'FitnessService']

function FrontCtrl(scope, rootScope, ionicPopup, state, toastr, common, UserService, FitnessService) {
    scope.appRootDir = appRootDir;
    scope.settings = settings;

	scope.common = common;

    scope.setLanguage = UserService.setLanguage;
    scope.getLangCode = UserService.getLangCode;

    scope.getConfirmableEvents = FitnessService.getConfirmableEvents;
    scope.getUserCanConfirm = FitnessService.getUserCanConfirm;

    rootScope.$evalAsync(() => { //Only broadcast to front if front has been initialized.
        rootScope.frontInitiated = true;
    });

    scope.stateGo = (target) => {
        state.go(target);
    };

    const locationId = (fitCalLocationId && fitCalLocationId != -1) ? fitCalLocationId : false;

    scope.frontLogoSrc = (locationId && settings.frontLogoSrcByLocation && settings.frontLogoSrcByLocation[locationId] ? settings.frontLogoSrcByLocation[locationId] : settings.defaultFrontLogoSrc);

    scope.shopUrl = () => settings.shopUrl;

    scope.showLocationSelector = false;

    scope.$on('$ionicView.enter', () => { //Forcefully close toastr here too. Some bug can leave it active. Unable to replicate though.
        toastr.clear();
    });

    //getterSetter function used by select ng-model="selectedLocation"
    scope.selectedLocation = (newLocation) => {
        if (typeof newLocation !== 'undefined') {
            common.setSelectedLocation(newLocation);

            //Set frontlogo to match new location
            scope.frontLogoSrc = (newLocation.locationSettings && newLocation.locationSettings.images && newLocation.locationSettings.images.logo) ? newLocation.locationSettings.images.logo : settings.defaultFrontLogoSrc;
        }

        return common.selectedLocation;
    };

    scope.getFresh = (pull) => {
        const promises = [
            UserService.getMobileAppSettings()
        ];

        if (settings.fitnessEnabled) {
            promises.push(FitnessService.getFitnessData());
            console.log(`[${performance.now()}] Calling FitnessService.getFitnessData() from FrontCtrl.scope.getFresh()`);
        }

        Promise.all(promises).then((pull) => {
            scope.$evalAsync(() => {
                if (pull)
                    scope.$broadcast('scroll.refreshComplete');
            });
        }).catch((error) => {
            common.writeToServerErrorLog('logTypeMisc', "getFresh returned error: " + JSON.stringify(error));
            
            scope.$evalAsync(() => {
                scope.$broadcast('scroll.refreshComplete');
            });
        });
    };
    
    scope.confirmEventPicker = (confirmableEventsArray) => {
        const buttons = [];

        if (confirmableEventsArray) {
            for (const event of confirmableEventsArray) {
                buttons.push({
					text: event.name + "<br>\n" + FitnessService.getTimeDisplayFormat(event, true),
                    type: 'button-positive',
                    onTap: (e) => event.activityId
                });
            }
        }

        buttons.push({
            text: _locale('cancel').ucfirst(),
            type: 'button-positive',
            onTap: (e) => false
        });

        return ionicPopup.show({
            title: _locale('open event').ucfirst(),
            scope: scope,
            cssClass: "popup-vertical-buttons",
            buttons: buttons
        });
    };

    scope.confirmEvents = () => {
        const confirmableEventsArray = scope.getConfirmableEvents();

        if (confirmableEventsArray.length > 1) {
            scope.confirmEventPicker(confirmableEventsArray).then((pickedActivityId) => {
                if (!pickedActivityId)
                    return false;

                state.go('app.showeventfront', { activityId: pickedActivityId });
            }).finally(() => common.fixModalOpen());
        }
        else if (confirmableEventsArray.length === 1) {
            state.go('app.showeventfront', { activityId: confirmableEventsArray[0].activityId });
        }
    };

    scope.newConfirmPopupShown = false;

    /*
    //Should i have a timer to reset newConfirmPopupShow? Or reset it when user confirms
    scope.$watch(() => ((['app.showeventfront', 'app.showevent', 'app.fitness'].indexOf(state.current.name) === -1) && (scope.getUserCanConfirm() && scope.getConfirmableEvents().length > 0)), (newVal, oldVal, scope) => {
        if (!scope.newConfirmPopupShown && newVal && !oldVal) {
            scope.newConfirmPopupShown = true;

            let popupPromise = ionicPopup.alert({
                title: "Jumppa tapahtuma",
                template: scope.getConfirmableEvents().length > 1 ? "c jumppa tapahtumia" : "Sinulla on vahvistamaton jumppa tapahtuma"
            });

            common.ionicPopupHandler(popupPromise, 3000);
        }
    });
    */
}

FrontCtrl.$inject = $inject

export default FrontCtrl